
<script>
// This component defines a basic honeypot for simple automated bots
// The input emit means "valid = false"
export default {
  props: {
    modelValue: Boolean,
  },
  emits: ['update:modalValue'],
  methods: {
    invalidate() {
      return "@emit('update:modelValue', false)"
    }
  }
};
</script>

<style scoped>
div {
  position: absolute;
  top: 0;
  left: 0;
  height: 0;
  width: 0;
  z-index: -1;
  opacity: 0;
}
</style>

<template>
  <div>
    <input class="viod-name" autocomplete="off" :placeholder="$t('components.captcha.name')" type="text"
      @input="invalidate" />
    <input class="viod-emailconfirm" type="email" autocomplete="off" :placeholder="$t('components.captcha.confirm_email')"
      @input="invalidate" />
    <input class="viod-remember-me" type="checkbox" autocomplete="off" @input="invalidate" />
    <p>{{ $t("components.captcha.remember_me") }}</p>
  </div>
</template>
